import React, { useEffect, useState } from 'react';
import back from '../dist/webImages/back.svg';
import { Form, Formik } from 'formik';
import { Link, useNavigate, useParams } from 'react-router-dom';
import swal from 'sweetalert';
import { toast } from 'react-toastify';
import FormControl from '../components/form/FormControl';
import SubmitButton from '../components/SubmitButton';
import useGet from '../customHooks/useGet';
import usePost2 from '../customHooks/usePost2';

const EditPeopleVisit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [resget, apiMethodGet] = useGet();
  const [res, apiMethod] = usePost2();
  const [datas, setDatas] = useState({});

  useEffect(() => {
    apiMethodGet(`people-visits/${id}`);
  }, [id]);

  useEffect(() => {
    if (res.error) {
      toast.error(res?.error?.response?.data?.message ?? 'Failed to update people visit');
    }
  }, [res.error]);

  useEffect(() => {
    if (res.data) {
      const { status, message } = res.data;

      if (status === 'false' || status === false) {
        toast.error(message);
        return;
      }

      toast.success(message ?? 'People visit updated successfully');
      navigate('/people-visits');
    }
  }, [navigate, res.data]);

  const peopleVisitData = resget?.data?.data ?? {};

  useEffect(() => {
    if (peopleVisitData && Object.keys(peopleVisitData).length > 0) {
      setDatas({
        slug: peopleVisitData?.slug ?? '',
      });
    }
  }, [peopleVisitData]);

  const initialValues = {
    slug: datas?.slug ?? peopleVisitData?.slug ?? '',
  };

  const handleSubmit = async (values) => {
    if (!values.slug?.trim()) {
      swal({
        title: 'Required fields are empty',
        text: 'Slug',
        icon: 'error',
        dangerMode: true,
      });
      return;
    }

    await apiMethod(`people-visites/${id}`, {
      slug: values.slug.trim(),
    });
  };

  if (resget.isLoading || !resget.data) {
    return (
      <section className='PushNotificationCreate pr-10 max-lg:pr-6'>
        <Link to='/people-visits' className='back flex items-center mb-5 gap-2'>
          <img src={back} className='w-[2rem]' alt='' />
          <span className='text-[1.4rem] font-MluvkaBold'>Edit People Visit</span>
        </Link>
        <div className='bg-white rounded-xl w-full mx-auto p-6 animate-pulse h-[12rem]' />
      </section>
    );
  }

  return (
    <section className='PushNotificationCreate pr-10 max-lg:pr-6'>
      <Link to='/people-visits' className='back flex items-center mb-5 gap-2'>
        <img src={back} className='w-[2rem]' alt='' />
        <span className='text-[1.4rem] font-MluvkaBold'>Edit People Visit</span>
      </Link>

      <div className='relative flex items-start gap-3'>
        <div className='bg-white rounded-xl w-full mx-auto relative'>
          <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
            <Form name='peopleVisitsEditForm'>
              <div className='bg-[#EFF4FD] p-6 rounded-3xl mb-3 max-lg:p-3'>
                <FormControl
                  name='slug'
                  label='Slug'
                  placeholder='Enter slug'
                  className='outline-none w-full h-[3rem] px-5 rounded-xl'
                  control='input2'
                />
              </div>

              <SubmitButton
                props={{
                  class: 'btn bg-secondary text-white px-12 ml-auto uppercase mb-3 py-3 rounded-full w-100 block mt-5 submit hover:bg-primary transition-all duration-300',
                  text: 'Update',
                }}
                buttonLoading={res.isLoading}
              />
            </Form>
          </Formik>
        </div>
      </div>
    </section>
  );
};

export default EditPeopleVisit;
